

import EntityFieldsFactory from "@/services/criteria/EntityFieldsFactory";
import criteriaScreenService from "@/services/screen/criteria";
import retroScreenService from "@/services/screen/retro";

export default {
  data() {
    return {
      form: {
        criteriaFields: [],
        retroalimentationFields: []
      },
      groupCriteriaFieldsScreen: [],
      groupRetroFieldsScreen: []
    }
  },
  methods: {
    async getEntityFields() {
      let criteria = this.createCriteriaFieldsByEntity();
      this.mountCriteriaFieldsByCriteria(criteria);
      this.mountRetroFieldsByCriteria(criteria);
    },
    createCriteriaFieldsByEntity() {
      let criteria = EntityFieldsFactory.create(this.chosenEntityType.slug);
      if (this.form.entityId) {
        criteria.setEntityId(this.form.entityId);
      }
      return criteria.setEntityTypeId(this.chosenEntityType.value).setClientId(this.form.clientId);
    },
    async mountCriteriaFieldsByCriteria(criteria) {
      this.groupCriteriaFieldsScreen = await criteriaScreenService
        .setCriteria(criteria)
        .mount();
    },
    async mountRetroFieldsByCriteria(criteria) {
      this.groupRetroFieldsScreen = await retroScreenService
        .setCriteria(criteria)
        .mount();
    },
    addRetroalimentationField(field = null) {
      if (!field) {
        field = {
          toFieldId: null,
          toFieldIdType: "",
          type: "",
          cac_descricao: ""
        }
      }
      this.form.retroalimentationFields.push({
        field,
        sectionAndFieldIds: [null, null],
        mustDeleteToFieldValueWhenFromSectionFieldIsNull: false
      });
    },
    addDefaultFieldsToRetroalimentation() {
      if (this.hasDefaultRetroFieldsEnabled) {
        let alternativeIdentifierField = this.getPropertyFieldFromRetroGroup("alternativeIdentifier")
        let descriptionField = this.getPropertyFieldFromRetroGroup("description")
        this.addRetroalimentationField(alternativeIdentifierField)
        this.addRetroalimentationField(descriptionField)
      }
    },
    getPropertyFieldFromRetroGroup(toFieldId) {
      let propertyGroup = this.groupRetroFieldsScreen.find(group => group.fieldType == "property")
      return propertyGroup.fields.find(field => field.toFieldId == toFieldId)
    },
    isDefaultFieldsValuesEmpty() {
      let isEmptyValues = false
      this.form.retroalimentationFields.forEach(retro => {
        if (["alternativeIdentifier", "description"].includes(retro.field.toFieldId)) {
          if (!retro.sectionAndFieldIds[1])
            isEmptyValues = true
        }
      })
      return isEmptyValues
    },
    removeRetroalimentationaField(index) {
      this.form.retroalimentationFields.splice(index, 1);
    },
    addCriteriaField() {
      this.form.criteriaFields.push({
        field: {
          field: null,
          fieldType: "",
          cac_descricao: ""
        },
        sectionAndFieldIds: [null, null]
      });
    },
    removeCriteriaField(index) {
      this.form.criteriaFields.splice(index, 1);
    }
  }
};
